export const DIRECT_BUY_REQUEST ='DIRECT_BUY_REQUEST';
export const DIRECT_BUY_REQUEST_SUCCESS ='DIRECT_BUY_REQUEST_SUCCESS';
export const DIRECT_BUY_REQUEST_FAIL ='DIRECT_BUY_REQUEST_FAIL';